<template>
    <div id="container-controls-id" class="container-controls d-flex align-items-center h-100">
        <div class="mr-auto py-0 py-sm-0 px-2">
            <div class="d-flex execution-bar">
                <div id="backwards-control"
                     class="icon-execution-bar buttonBar"
                     @click="buttonBackwardVideo"
                     v-if="showForwardAndBackward === 'showFWBW'">
                    <i class="icon-button-bar icon-previous size-icon-arrow"></i>
                </div>
                <div class="py-sm-1 py-md-1 py-1 px-0 px-sm-1"> <!--  style="margin-top: 2px;" -->
                    <!-- Boton de pausa del video -->
                    <div id="bottom-bar-pause-button" class="buttonBar hover-colorable"
                         @click="buttonPauseVideo">
                        <div class="innerSvg slick-button-hover">
                            <img alt=""
                                 src="/../build/images/img_fe_v2m/svg/pause_control_video.svg" class="size-icon-play">
                        </div>
                    </div>
                    <!-- Boton de ejecucion del video -->
                    <div id="bottom-bar-play-button" class="buttonBar hover-colorable"
                         @click="buttonPlayVideo" ref="btnPlay">
                        <div id="play-control">
                            <div class="innerSvg slick-button-hover">
                                <img alt=""
                                     src="/../build/images/img_fe_v2m/svg/play_control_video.svg" class="size-icon-play">
                            </div>
                        </div>
                    </div>
                </div>
                <div id="forwards-control"
                     class="icon-execution-bar buttonBar"
                     @click="buttonForwardsVideo"
                     v-if="showForwardAndBackward === 'showFWBW'">
                    <i class="icon-button-bar icon-next size-icon-arrow"></i>
                </div>
            </div>
        </div>
        <div class="py-0 px-2">
            <div class="d-flex align-items-center">
                <div id="container-console-video-check" class="container-icon-bar"
                     v-if="isDebug === 'true'">
                    <div class="form-check form-switch" @click="showConsole" style="min-height: auto; margin-bottom: 0;">
                        <input class="form-check-input" type="checkbox" role="switch" id="checkbox-console-video">
                        <label class="form-check-label" for="checkbox-console-video">Console</label>
                    </div>
                </div>
                <div id="time-video-data" class="container-icon-bar container-time-video">
                    <div class="time-video-data">
                        <span class="container-current-time-video">{{ getCurrentTimePlayer }}</span><span class="container-total-time-video"> / {{ videoDurationFormatted }}</span>
                    </div>
                </div>
                <div class="container-icon-bar container-volume-video"
                     @mouseleave="mouseLeaveVolumeButton">
                    <div id="containerVolume" class="option-bar volume-control background-colorable">
                        <div class="volume-bar-slider-container">
                            <div id="volume-bar" class="volume-bar colorable">
                                <input id="volume-bar-slider" class="volume-bar-slider" type="range" value="50" min="0" max="100">
                            </div>
                        </div>
                        <div id="volume-bar-icon" class="volumeControllerSvg inactive"
                             @click="buttonVolume"
                             @mouseenter="mouseEnterVolumeButton"
                             style="pointer-events: auto;">
                            <div id="speaker" class="slick-button-hover">
                                <img alt="" id="speaker-active" class="size-icon"
                                     src="/../build/images/img_fe_v2m/svg/speaker_control_video.svg">
                                <img alt="" id="speaker-inactive" class="size-icon"
                                     src="/../build/images/img_fe_v2m/svg/speaker_control_video_of.svg"
                                     style="display: none;">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-icon-bar container-cc-video"
                     v-if="getSubtitles.length > 0">
                    <div id="cc-button" class="option-bar cc-control"> <!--  @mouseleave="mouseLeaveCCButton" -->
                        <!--div id="cc-menu" class="vjs-menu" role="presentation" style="z-index:100;">
                            <ul class="vjs-menu-content" role="menu">
                                <li v-for="(subtitle, index) in getSubtitles"
                                    :key="index"
                                    :id="'subtitle-' + subtitle.id"
                                    @click="changeSubtitle(subtitle.id)"
                                    :class="[subtitle.active ? 'active' : '']"
                                    class="vjs-menu-item subtitle" tabindex="-1" role="menuitem" aria-live="polite">
                                    <span class="vjs-control-text text-capitalize">{{ subtitle.languageDescription }}</span>
                                </li>
                            </ul>
                        </div-->
                        <div id="cc-control-icon" style="pointer-events: auto;">
                            <div id="cc-icon" class="slick-button-hover" @click="manageSubtitles" @mouseenter="mouseEnterCCButton">
                                <i id="iconSubtitle" class="icon-button-bar icon-cc-on size-icon-lg"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-icon-bar container-settings-video">
                    <div id="settings-button" class="option-bar settings-control" @mouseleave="mouseLeaveSettingsButton">
                        <div class="settings-container-menu">
                            <div id="resolutions-menu" class="vjs-menu" role="presentation">
                                <ul class="vjs-menu-content" role="menu">
                                    <li v-for="(resolution, index) in getVideoResolutions"
                                        :key="index"
                                        :id="'resolution-' + resolution.resolutionId"
                                        @click="changeResolution(index, resolution.resolutionId)"
                                        :class="[resolution.active ? 'active' : '']"
                                        class="vjs-menu-item resolution" tabindex="-1" role="menuitem" aria-live="polite">
                                        <span class="vjs-control-text text-capitalize">{{ resolution.resolutionType }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div id="settings-control-icon" style="pointer-events: auto;">
                            <div id="settings-icon" class="slick-button-hover"
                                 @mouseenter="mouseEnterSettingsButton">
                                <i class="icon-button-bar icon-settings size-icon"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-icon-bar container-fullscreen-video">
                    <div id="fullscreen-button" class="option-bar fullscreen-control">
                        <div id="fullscreen-control-icon" style="pointer-events: auto;">
                            <div id="fullscreen-icon" class="slick-button-hover" @click="fullscreen">
                                <img alt="" id="fullscreen-active" class="size-icon"
                                     src="/../build/images/img_fe_v2m/svg-play/enter_fullscreen_video.svg">
                                <img alt="" id="fullscreen-inactive" class="size-icon"
                                     src="/../build/images/img_fe_v2m/svg-play/exit_fullscreen_video.svg"
                                     style="display: none;">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import { executeFullScreen } from "@/playerVue3/services/video-service";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS & EMITS
const props = defineProps({
    currentTimePlayer: {
        type: Number,
        default: 0,
    },
});

const emit = defineEmits(['hidden-btn-unmute-autoplay']);

// REACTIVE VARIABLES
const timeDragVolume = ref(false);
const videoDurationFormatted = ref('');
const videoDurationToShow = ref(0);

// COMPUTED PROPERTIES
const getCurrentTimePlayer = computed(() => {
    return formatTime(props.currentTimePlayer);
});

const getSubtitles = computed(() => {
    let arrSubtitles = [];
    if (store.getVideoData.subtitle && store.getVideoData.subtitle.length > 0) {
        let subtitleID = 1;
        arrSubtitles.push({
            "id": -1,
            "file": "",
            "languageDescription": "Off",
            "active": true,
        });
        store.getVideoData.subtitle.forEach(function (data, index) {
            arrSubtitles.push({
                "id": subtitleID,
                "file": store.getPathLocalOrServer + "videos/subtitles/" + data.name,
                "languageDescription": data.language.description,
                "active": false,
            });
            subtitleID++;
        })
    }
    return arrSubtitles;
});

const getVideoResolutions = computed(() => {
    return store.getVideoData.resolutions;
});

const isDebug = computed(() => {
    return store.getIsDebug;
});

const showForwardAndBackward = computed(() => {
    // 1 = Hide Timeline, 2 = Show Timeline
    let typeBar = 'hideFWBW';
    if (store.getVideoData.typePlayBar.typePlayBarId === 2) {
        typeBar = 'showFWBW';
    } else if (store.getVideoData.typePlayBar.typePlayBarId === 1 && store.getModeAdmin) {
        typeBar = 'showFWBW';
    }
    return typeBar;
});

// METHODS
const buttonBackwardVideo = () => {
    store.getPlayer.pause();
    setTimeout(() => {
        store.getPlayer.seek(store.getPlayer.getPosition() - 3);
        buttonPlayVideo();
    }, 5);
};

const buttonForwardsVideo = () => {
    store.getPlayer.pause();
    setTimeout(() => {
        store.getPlayer.seek(store.getPlayer.getPosition() + 3);
        buttonPlayVideo();
    }, 5);
};

const autoPlayVideo = () => {
    const referrer = document.referrer
    const origin = document.location.origin

    if (referrer.includes(origin)) {
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            buttonVolume();
        }
    } else {
        buttonVolume();
    }
    if (store.getPlayer.getMute()) {
        store.setIsFetchingBtnUnmuteAutoplay(false);
    }
    buttonPlayVideo();
};

const buttonPlayVideo = () => {
    store.getPlayer.play();
    store.setVideoIsPlaying(true);
};

const buttonPauseVideo = () => {
    store.getPlayer.pause();
    store.setVideoIsPlaying(false);
};

const hiddenBtnUnmuteAutoplay = () => {
    if (store.getIsAutoPlay && store.getPlayer.getMute()) {
        emit('hidden-btn-unmute-autoplay');
    }
};

const buttonVolume = () => {
    let position = 0;
    const actualVolumeVideo = store.getPlayer.getVolume();
    const volumeBarSlider = $('input#volume-bar-slider');

    hiddenBtnUnmuteAutoplay();

    if (actualVolumeVideo > 0 && !store.getPlayer.getMute()) {
        position = 0;
        $('#speaker-active').hide();
        $('#speaker-inactive').show();
        volumeBarSlider.val(position);
        store.getPlayer.setMute(true);
    } else {
        position = actualVolumeVideo;// * 100;
        $('#speaker-active').show();
        $('#speaker-inactive').hide();
        volumeBarSlider.val(position);
        store.getPlayer.setMute(false);
        store.setIsFetchingBtnUnmuteAutoplay(true);
    }
};

const changeResolution = (index, resolutionID) => {
    store.setCurrentResolutionSelected(index);
    store.getPlayer.setCurrentQuality(index);
    $('.resolution').removeClass('active');
    $('#resolution-' + resolutionID).addClass('active');
};

const changeSubtitle = (subtitleID) => {
    store.getPlayer.setCurrentCaptions(subtitleID);
    $('.subtitle').removeClass('active');
    $('#subtitle-' + subtitleID).addClass('active');
};

const formatTime = (duration) => {
    duration = duration * 1000;
    let milliseconds = parseInt((duration%1000))
        , seconds = parseInt((duration/1000)%60)
        , minutes = parseInt((duration/(1000*60))%60)
        , hours = parseInt((duration/(1000*60*60))%24);

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    if (hours === '00') {
        return minutes + ":" + seconds;
    }

    return hours + ":" + minutes + ":" + seconds;
};

const fullscreen = () => {
    executeFullScreen(store);
};

const mouseEnterCCButton = () => {
    //$('#cc-menu').css('display', 'block');
    //$('#cc-menu').css('pointer-events', 'auto');
    $('#resolutions-menu').css('display', 'none');
    $('#resolutions-menu').css('pointer-events', 'none');
    $('#volume-bar-progress').css('display', 'none');
    $('#volume-bar').css('display', 'none');
    $('.volume-bar-slider-container').css('display', 'none');
};

const manageSubtitles = () => {
    if (store.getPlayer.getCurrentCaptions() === -1 || store.getPlayer.getCurrentCaptions() === 0) {
        $('#iconSubtitle').removeClass('icon-cc-off').addClass('icon-cc-on');
        store.getPlayer.setCurrentCaptions(1);
        $('.subtitle').removeClass('active');
        $('#subtitle-1').addClass('active');
    } else {
        $('#iconSubtitle').removeClass('icon-cc-on').addClass('icon-cc-off');
        store.getPlayer.setCurrentCaptions(-1);
        $('.subtitle').removeClass('active');
        $('#subtitle--1').addClass('active');
    }
};

const mouseEnterSettingsButton = () => {
    $('.settings-container-menu').css('display', 'block');
    $('#resolutions-menu').css('display', 'block');
    $('#resolutions-menu').css('pointer-events', 'auto');
    $('#volume-bar-progress').css('display', 'none');
    $('#volume-bar').css('display', 'none');
    $('.volume-bar-slider-container').css('display', 'none');
    //$('#cc-menu').css('display', 'none');
    //$('#cc-menu').css('pointer-events', 'none');
};

const mouseEnterVolumeButton = () => {
    $('.volume-bar-slider-container').css('display', 'block');
    $('#volume-bar').css('display', 'flex');
    //$('#containerVolume').css('pointer-events', 'auto');

    $('#resolutions-menu').css('display', 'none');
    $('#resolutions-menu').css('pointer-events', 'none');
    //$('#cc-menu').css('display', 'none');
    //$('#cc-menu').css('pointer-events', 'none');
};

/*const mouseLeaveCCButton = () => {
    setTimeout(() => {
        if ($("#cc-menu:hover").length == 0) {
            $('#cc-menu').css('display', 'none');
            $('#cc-menu').css('pointer-events', 'none');
        }
    }, 500);
};*/

const mouseLeaveSettingsButton = () => {
    setTimeout(() => {
        if ($("#resolutions-menu:hover").length == 0) {
            $('#resolutions-menu').css('display', 'none');
            $('#resolutions-menu').css('pointer-events', 'none');
            $('.settings-container-menu').css('display', 'none');
        }
    }, 1000);
};

const mouseLeaveVolumeButton = () => {
    setTimeout(() => {
        if ($(".volume-bar-slider-container:hover").length == 0) {
            //$('#volume-bar-slider').css('display', 'none');
            $('#volume-bar-progress').css('display', 'none');
            $('#volume-bar').css('display', 'none');
            $('.volume-bar-slider-container').css('display', 'none');
            //$('#containerVolume').css('pointer-events', 'none');
        }
    }, 1000);
};

const showConsole = () => {
    //valid if checkbox is checked
    if ($('#checkbox-console-video').is(':checked')) {
        $('#console-overlay').css('display', 'block');
    } else {
        $('#console-overlay').css('display', 'none');
    }
};

const updateVolumeBar = () => {
    // Capturamos la posición del slider que controla el volumen del video
    let position = $('input#volume-bar-slider').val();
    // Validamos que la posición no sea mayor que: 100 y menor que: 0
    if (position > 100) {
        position = 100;
    } else if (position < 0) {
        position = 0;
    }

    // Validamos la posición para hacer el cambio de icono
    if (position > 0) {
        $('#speaker-active').show();
        $('#speaker-inactive').hide();
    } else {
        $('#speaker-active').hide();
        $('#speaker-inactive').show();
    }
    hiddenBtnUnmuteAutoplay();
    store.getPlayer.setVolume(parseInt(position));
};

// LIFECYCLE HOOKS
onMounted(() => {
    const _this = this;
    videoDurationToShow.value = parseFloat(store.getVideoData.duration).toFixed(0);
    videoDurationFormatted.value = formatTime(videoDurationToShow.value);

    $(document).on('change', '#volume-bar', function () {
        timeDragVolume.value = true;
        updateVolumeBar();
    });

    $(document).on('mouseup ', '#volume-bar', function () {
        if (timeDragVolume.value) {
            timeDragVolume.value = false;
            updateVolumeBar();
        }
    });

    $(document).on('mousemove', '#volume-bar', function () {
        if (timeDragVolume.value) {
            updateVolumeBar();
        }
    });

    $('#bottom-bar-pause-button').hide();
});

watch (() => store.getPlayerIsReady, (newVal) => {
    if (newVal == true) {
        if (store.getIsAutoPlay && jsEnabled == 0) {
            autoPlayVideo();
        }

        if (store.getVideoData.subtitle && store.getVideoData.subtitle.length > 0) {
            store.getPlayer.setCurrentCaptions(-1);
            $('#iconSubtitle').removeClass('icon-cc-on').addClass('icon-cc-off');
        }
    }
});

watch (() => store.getIsVideoMuted, (newVal) => {
    if (newVal) {
        buttonVolume();
    }
});
</script>
